import { Alert, Box, Button, Stack, Text } from '@chakra-ui/react'
import { Product } from 'brokertslib/src/enums'
import { useGetInsurers } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useMemo } from 'react'

import { useAuth } from '@/context/AuthContext'

import { Loading } from '../../components/Loading'
import { Refresh } from '../../icons'
import { SectionHeading } from '../shared/SectionHeading'
import { OrganizationDiscountsTable } from './OrganizationDiscountTable'

export const OrganizationDiscounts = ({
  organizationUnitId,
}: {
  organizationUnitId: number
}) => {
  return (
    <>
      <Box sx={{ display: 'grid', gap: 4 }}>
        <SectionHeading>Pojištění vozidel</SectionHeading>
        <OrganizationDiscountsCategory
          organizationUnitId={organizationUnitId}
          insuranceCategoryType={Product.VehicleInsurance}
        />
      </Box>

      <Box sx={{ display: 'grid', gap: 4 }}>
        <SectionHeading>Pojištění majetku a odpovědnosti</SectionHeading>
        <OrganizationDiscountsCategory
          organizationUnitId={organizationUnitId}
          insuranceCategoryType={Product.PropertyInsurance}
        />
      </Box>

      <Box sx={{ display: 'grid', gap: 4 }}>
        <SectionHeading>Cestovní pojištění</SectionHeading>
        <OrganizationDiscountsCategory
          organizationUnitId={organizationUnitId}
          insuranceCategoryType={Product.TravelInsurance}
        />
      </Box>

      <Box sx={{ display: 'grid', gap: 4 }}>
        <SectionHeading>Pojištění odpovědnosti</SectionHeading>
        <OrganizationDiscountsCategory
          organizationUnitId={organizationUnitId}
          insuranceCategoryType={Product.LiabilityInsurance}
        />
      </Box>
    </>
  )
}

const OrganizationDiscountsCategory = ({
  organizationUnitId,
  insuranceCategoryType,
}: {
  organizationUnitId: number
  insuranceCategoryType: Product
}) => {
  const { data, refetch, isError, isLoading, isFetching } = useGetInsurers(
    organizationUnitId,
    insuranceCategoryType,
  )

  const auth = useAuth()
  const isEditDisabled = useMemo(
    () => !auth?.user?.allowEditOrganizationStructure,
    [auth],
  )

  return isLoading ? (
    <Loading large />
  ) : isError ? (
    <Alert status="error" p={8} alignItems="center" justifyContent="center">
      <Stack gap={4}>
        <Text fontSize="lg" fontWeight="semibold">
          Nepodařilo se načíst data
        </Text>
        <Button colorScheme="secondary" onClick={() => refetch()}>
          <Refresh />
          Načíst znovu
        </Button>
      </Stack>
    </Alert>
  ) : data && data.length > 0 ? (
    <OrganizationDiscountsTable
      insurers={data}
      isEditDisabled={isEditDisabled}
      isFetching={isFetching}
    />
  ) : (
    <Text>Žádné přidělené pojišťovny</Text>
  )
}
